// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-m_fy","advertDetailContacts__header":"c-m_fz"};